import { uniformGrid } from '../settingsHelpers';
import { DIMENSIONS, ITEMS, MS, TS, UNITS } from '../../constants';
const { width, depth, height } = DIMENSIONS;

export default {
  grid: uniformGrid(1),
  defaultFilter: 'frames',
  postWidth: 11,
  padHeight: 5,
  roomMinDesktop: {
    width: 0,
    height: 2500,
  },
  roomMinSummary: {
    width: 1000,
    height: 1000,
  },
  roomMinMobile: {
    width: 2200,
    height: 2200,
  },
  distanceBetweenAttachments: 162,
  roomMax: {
    width: 4500,
    height: 3000,
  },
  zoomableScene: true,
  canvasMargins: { top: 30, right: 60 },
  canvasMarginsKiosk: { top: 30, right: 100 },
  canvasMarginsMobile: {
    top: 50,
    right: 40,
  },
  displaySectionMeasurements: false,
  measurements: {
    productsRemap: [],
    displayMeasurement: [
      {
        affects: [ITEMS.FRAME, ITEMS.SHELVING_UNIT],
        rules: {
          display: true,
          measure: false,
          measurementPrefix: false,
          format: `${width}${TS}${depth}${TS}${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [ITEMS.CLOTHES_RAIL, ITEMS.BASKET, ITEMS.TOP_SHELF],
        rules: {
          display: false,
          measure: false,
          measurementPrefix: false,
          format: `${height}${TS}${width} ${MS}`,
          unit: UNITS.cm,
        },
      },
    ],
  },
  hideInfoIconForType: [],
  bulkArticles: {},
  colorCodes: {
    white: '#F8F8F7',
    anthracite: '#383E42',
    grey: '#929191',
  },
};
